import { Phone, Mail } from "lucide-react";

const mailto = (e) => {
  const data = new Date(e.enviada_at).toLocaleDateString("pt-PT");
  const n = e.codigo || `#${e.numero}`;
  const subject = `Encomenda ${n} — ponto de situação`;
  const body = `Bom dia,\n\nGostaríamos de saber o ponto de situação da nossa encomenda ${n}, enviada a ${data}, que ainda tem as seguintes linhas por receber:\n\n${(e.linhas || []).map((l) => `- ${l}`).join("\n")}\n\nObrigado.\nCumprimentos`;
  return `mailto:${e.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const cls = "shrink-0 w-8 rounded-md border flex items-center justify-center transition-colors";

export const ContactarFornecedor = ({ enc }) => (
  <>
    {enc.telefone ? (
      <a href={`tel:${enc.telefone.replace(/\s/g, "")}`} title={`Ligar ${enc.telefone}`} data-testid={`copilot-ligar-${enc.numero}`}
        className={`${cls} border-emerald-200 bg-white text-emerald-600 hover:bg-emerald-50`}><Phone size={13} /></a>
    ) : (
      <span title="Fornecedor sem telefone registado" className={`${cls} border-slate-200 text-slate-300`}><Phone size={13} /></span>
    )}
    {enc.email ? (
      <a href={mailto(enc)} title={`Email para ${enc.email}`} data-testid={`copilot-email-${enc.numero}`}
        className={`${cls} border-indigo-200 bg-white text-indigo-600 hover:bg-indigo-50`}><Mail size={13} /></a>
    ) : (
      <span title="Fornecedor sem email registado" className={`${cls} border-slate-200 text-slate-300`}><Mail size={13} /></span>
    )}
  </>
);
